<template>
  <div>
    <vue-tags-input
      class="UserList__input"
      :placeholder="$t('evenement.shares.placeholder')"
      :autocomplete-items="suggestions"
      v-model="query"
      :tags="tags"
      avoid-adding-duplicates
      @adding-duplicate="error_email.double = true"
      @tags-changed="update"
      @before-adding-tag="checkEmail"
    >
      <template slot="autocomplete-header">
        <strong>{{ $t("suggestions") }}</strong>
      </template>
      <div
        slot="autocomplete-item"
        slot-scope="props"
        class="UserList__search-items"
        :class="{
          notActivated: !props.item.activated,
          noLicence: !props.item.hasLicence
        }"
        @click="props.performAdd(props.item)"
      >
        <div style="width: 50px">
          <img
            style="border-radius:50%;max-width:30px;"
            :src="imageProfil(props.item.picture)"
            alt="img-user"
          />
        </div>
        <div class="UserListRow__infos">
          <span style="font-weight: 700;" v-if="props.item.name.length > 1">{{
            props.item.name
          }}</span>
          <span style="font-style: italic;" v-else>{{
            $t("title.guestUser")
          }}</span>
          <span style="float: right;">
            <b-tooltip
              v-if="props.item.hasLicence === false"
              :label="$t('user.noLicence', { outil: capitaliseOutil })"
              position="is-right"
              type="is-dark"
            >
              <b-icon icon="exclamation-circle" size="is-small" />
            </b-tooltip>
          </span>

          <br />
          <span>{{ props.item.text }}</span>
          <small style="float: right;" v-if="!props.item.activated">{{
            $t("user.notactivated")
          }}</small>
        </div>
      </div>
    </vue-tags-input>
    <div style="min-height: 20px;">
      <transition name="slide-fade">
        <small class="error_email" v-if="error_email.invalid">
          <b-icon icon="exclamation-circle" size="is-small" />
          {{ $t("error.email.invalid") }}
        </small>
      </transition>
      <transition name="slide-fade">
        <small class="error_email" v-if="error_email.double">
          <b-icon icon="exclamation-circle" size="is-small" />
          {{ $t("error.email.double") }}
        </small>
      </transition>
      <transition name="slide-fade">
        <small class="error_email" v-if="error_email.yours">
          <b-icon icon="exclamation-circle" size="is-small" />
          {{ $t("error.email.yours") }}
        </small>
      </transition>
    </div>

    <span slot="footer" class="dialog-footer" style="margin-top: 25px">
      <button class="button" @click="shareButton()">
        {{ $tc("button.sauvegarder") }}
      </button>
    </span>
  </div>
</template>

<script>
import VueTagsInput from "@johmun/vue-tags-input";
import axios from "axios";
import debounce from "lodash.debounce";

function isEmail(email) {
  const regEmail = new RegExp(
    "^[0-9a-z._-]{2,64}@{1}[0-9a-z.-]{2,}[.]{1}[a-z]{2,}$",
    "i"
  );
  return regEmail.test(email);
}

export default {
  props: ["evenement_id"],
  components: {
    VueTagsInput
  },
  name: "Shares",
  data() {
    return {
      tool: "eventify",
      suggestions: [],
      tags: [],
      query: "",
      pending: false,
      error_email: {
        invalid: false,
        double: false,
        yours: false
      }
    };
  },
  computed: {
    capitaliseOutil() {
      return this.tool.replace(/^\w/, c => c.toUpperCase());
    }
  },
  watch: {
    query() {
      this.error_email = {
        invalid: false,
        double: false,
        yours: false
      };
      this.search();
    }
  },
  mounted() {
    this.pending = true;
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + window.store.getters.userToken;
    axios
      .get(`${process.env.URL_SSO_API}Share/${this.tool}/${this.evenement_id}`)
      .then(response => {
        this.tags = response.data.map(query => {
          return { text: query.email };
        });
        this.pending = false;
      });
  },
  methods: {
    imageProfil(pictureUrl) {
      let url = process.env.URL_SSO_API.replace("api/v1/", "");
      if (pictureUrl) {
        return url + pictureUrl;
      } else {
        return url + "/uploads/appy/user/default-user-picture.png";
      }
    },
    shareButton() {
      if (!this.query.trim().length || isEmail(this.query.toLowerCase())) {
        const shares = this.tags.map(a => {
          return a.text;
        });
        const data = new FormData();
        data.append("_method", "PUT");
        data.append("shares", shares);
        this.pending = true;
        axios
          .post(
            `${process.env.URL_SSO_API}Share/${this.tool}/${this.evenement_id}`,
            data
          )
          .then(response => {
            this.$store.commit("MODAL_SHARES", {
              evenementId: null,
              activeModalShares: false
            });
            this.pending = false;
            this.$buefy.toast.open({
              type: "is-success",
              message: this.$i18n.t("toast.shares")
            });
          });
      } else {
        this.error_email.invalid = true;
      }
    },
    checkEmail(obj) {
      let email = obj.tag.text;
      if (email && this.$store.getters.currentUserEmail === email) {
        this.error_email.yours = true;
      } else if (email && isEmail(email)) {
        obj.tag.text = email.toLowerCase();
        obj.addTag();
      } else {
        this.error_email.invalid = true;
      }
    },
    update(newTags) {
      this.suggestions = [];
      this.tags = newTags;
    },
    search: debounce(async function() {
      if (this.query.length < 3) return (this.suggestions = []);

      axios.defaults.headers.common["Authorization"] =
        "Bearer " + window.store.getters.userToken;
      axios
        .get(
          `${process.env.URL_SSO_API}user/suggestion?orderBy=email,asc&fields=id,email,firstname,lastname,picture_url,group_id&paginate=15&page=1&q=${this.query}`
        )
        .then(response => {
          // on vérifie si l'utilisateur a son email dans la liste des shares et si c'est le cas on l'enleve
          let new_suggestions = response.data.filter(
            user => user.email !== this.$store.getters.currentUserEmail
          );

          // nouvelle object retourné dans les suggestions avec seulement les infos necessaires
          this.suggestions = new_suggestions.map(user => {
            const licence = user.licences.some(
              app => app.toLowerCase() == this.tool
            );
            return {
              text: user.email,
              name: user.firstname + " " + user.lastname,
              picture: user.picture_url,
              activated: user.activated,
              hasLicence: licence
            };
          });
        });
    }, 500)
  }
};
</script>

<style>
.UserList__input {
  z-index: 10;
  margin: auto;
}
.UserList__input div {
  border-radius: 0px;
  width: 100%;
}
.UserList__input li.ti-selected-item {
  background-color: #f5f7fa;
  color: #4e5053be;
}

.UserList__input li.ti-selected-item:hover {
  background-color: #f5f7fa;
}

.UserList__input li.ti-tag {
  border-radius: 3px;
  background-color: #f5f5f5;
  color: #4e5053;
}

.UserList__search-items {
  display: flex;
}

.notActivated {
  background-color: #f6f7f896; /* rgba(231, 231, 231, 0.568); */
  color: rgba(165, 165, 165, 0.555);
}

.UserListRow__profil-picture {
  border-radius: 50%;
  margin: 0 10px;
  width: 30px;
  height: 30px;
}

.UserListRow__infos {
  width: 100%;
  font-size: 12px;
}

.UserList__tag-picture {
  border-radius: 50%;
  margin-top: 1px;
  margin-right: 5px;
  width: 30px;
  height: 30px;
}

.error_email {
  color: red;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
.vue-tags-input {
  max-width: 100%;
}
.button {
  border-radius: 0px;
  background-color: #424a60;
  font-size: 12px;
  color: white;
}
.button:hover {
  border-radius: 0px;
  background-color: #424a60;
  font-size: 12px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/event/components/Shares.vue